module.exports = __webpack_public_path__ + "img/127.b44d2c2c.jpg";